import type { PageBackground } from '@lemonade-hq/uniclient-chat';
import { CoverBackground } from './CoverBackground';
import { SpreadBackground } from './SpreadBackground';

interface BackgroundProps {
  readonly background: PageBackground;
  readonly cardHeight: number;
}

export const Background: React.FC<BackgroundProps> = ({ background, cardHeight }) => {
  if (background.type === 'cover') {
    return <CoverBackground image={background.image} />;
  }

  return <SpreadBackground cardHeight={cardHeight} images={background.image} />;
};
